module.exports = __webpack_public_path__ + "static/media/houqinbaozhangbankuai.3c1e7efc.png";